import { Flex, FlexProps, Text, TextProps } from "@chakra-ui/react";
import { format } from "date-fns";
import { Calendar, Clock } from "@airhelp/icons";
import { ReactNode } from "react";
import { mapLocaleToDatePickerLocale } from "../../../../../app-settings/localesAndCurrencies";
import { useQuery } from "@tanstack/react-query";
import { appSettingsSnapshot } from "v2/settings";

export function FlightDetailsTextSection({
  label,
  text,
  ...props
}: FlexProps & {
  label: string;
  text: string | ReactNode;
}) {
  return (
    <Flex mb={2} direction="column" {...props}>
      <Text fontSize="sm" color="greyscale.600">
        {label}
      </Text>
      <Flex mt={1}>
        {typeof text === "string" ? (
          <FlightDetailsSectionText>{text}</FlightDetailsSectionText>
        ) : (
          text
        )}
      </Flex>
    </Flex>
  );
}

const ARRIVAL_DATE_FORMAT = "dd MMM yyyy";
const ARRIVAL_TIME_FORMAT = "HH:mm";

export function FlightDetailsArrivalSection({
  label,
  arrivalDate,
  wasArrivalDelayed,
  ...props
}: FlexProps & {
  label: string;
  arrivalDate: Date;
  wasArrivalDelayed?: boolean;
}) {
  const { locale } = appSettingsSnapshot();
  const { data: datePickerLocale } = useQuery({
    queryKey: ["localeDate", { locale }],
    queryFn: () => mapLocaleToDatePickerLocale(locale),
  });

  return (
    <FlightDetailsTextSection
      label={label}
      text={
        <>
          <Flex align="center">
            <Calendar boxSize={5} mr={2} color="greyscale.500" />
            <FlightDetailsSectionText mr={5}>
              {format(arrivalDate, ARRIVAL_DATE_FORMAT, { locale: datePickerLocale })}
            </FlightDetailsSectionText>
          </Flex>
          <Flex align="center" color="font.primary">
            <Clock boxSize={5} color={wasArrivalDelayed ? "danger.500" : "greyscale.500"} mr={2} />
            <FlightDetailsSectionText color={wasArrivalDelayed ? "danger.500" : "font.primary"}>
              {format(arrivalDate, ARRIVAL_TIME_FORMAT, { locale: datePickerLocale })}
            </FlightDetailsSectionText>
          </Flex>
        </>
      }
      {...props}
    />
  );
}

export function FlightDetailsSectionText(props: TextProps) {
  return <Text fontSize="md" color="font.primary" {...props} />;
}
